import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { api } from "../../lib/api";
import { AdminGate } from "../events/AdminGate";
import { fmtNum } from "./kitchenUtils";

const PER = { half_pan: "half pan", person: "person", each: "each" };
const Blank = () => <span className="inline-block border-b border-black w-full h-5" />;

const Item = ({ it }) => (
  <section className="break-inside-avoid border border-black/40 rounded p-3 mb-3" data-testid={`worksheet-item-${it.id}`}>
    <p className="font-black text-[14px]">{it.name}</p>
    {it.description && <p className="text-[11px] text-black/70 mb-1">{it.description}</p>}
    <p className="text-[11.5px] mb-1">Sold per: {Object.entries(PER).map(([k, v]) => `${it.basis === k ? "☒" : "☐"} ${v}`).join("  ")} &nbsp;·&nbsp; Serves per unit: ______ &nbsp;·&nbsp; Full pan = ______</p>
    <table className="w-full border-collapse text-[12px]">
      <thead><tr className="text-left"><th className="border border-black/40 p-1 w-1/2">What goes in</th><th className="border border-black/40 p-1">Amount per {PER[it.basis]}</th><th className="border border-black/40 p-1">Unit (slices, oz…)</th></tr></thead>
      <tbody>
        {it.components.map((c, i) => (
          <tr key={i}><td className="border border-black/40 p-1">{c.name}</td><td className="border border-black/40 p-1 font-bold">{c.amount != null ? fmtNum(c.amount) : <Blank />}</td><td className="border border-black/40 p-1">{c.unit_label || <Blank />}</td></tr>
        ))}
        {[0, 1, 2].map((i) => <tr key={`b${i}`}><td className="border border-black/40 p-1 h-7" /><td className="border border-black/40 p-1" /><td className="border border-black/40 p-1" /></tr>)}
      </tbody>
    </table>
    <p className="text-[11.5px] mt-1.5">Prep notes: <Blank /></p>
  </section>
);

function WorksheetInner() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/kitchen/worksheet").then((r) => setData(r.data)).catch(() => setData({ error: true })); }, []);
  if (!data) return <p className="p-6">Loading…</p>;
  if (data.error) return <p className="p-6" data-testid="worksheet-error">Couldn't load the worksheet. Reload to try again.</p>;
  const groups = data.items.reduce((acc, it) => ({ ...acc, [it.category]: [...(acc[it.category] || []), it] }), {});
  return (
    <div className="bg-white text-black p-6 max-w-[800px] mx-auto" data-testid="recipe-worksheet">
      <div className="flex items-center justify-between print:hidden mb-4">
        <p className="text-[13px]">{data.count} items need info</p>
        <button type="button" onClick={() => window.print()} data-testid="worksheet-print-button" className="h-10 px-4 rounded-full bg-black text-white text-[12px] font-bold inline-flex items-center gap-2"><Printer className="h-4 w-4" /> Print</button>
      </div>
      <h1 className="text-[22px] font-black">Recipe Worksheet — Missing Info</h1>
      <p className="text-[12px] mb-4">Fill in the blanks for each item, then hand it back so it can be entered. Printed {new Date().toLocaleDateString()}.</p>
      {data.count === 0 && <p data-testid="worksheet-empty">Every menu item has its amounts filled in.</p>}
      {Object.entries(groups).map(([cat, list]) => (
        <div key={cat}>
          <h2 className="text-[15px] font-black uppercase tracking-[0.1em] border-b-2 border-black mt-4 mb-2">{cat}</h2>
          {list.map((it) => <Item key={it.id} it={it} />)}
        </div>
      ))}
    </div>
  );
}

export default function RecipeWorksheetPage() {
  return <AdminGate><WorksheetInner /></AdminGate>;
}
